import { render } from "./EngineAvatarLink.vue?vue&type=template&id=06c77e94&scoped=true"
import script from "./EngineAvatarLink.vue?vue&type=script&lang=js"
export * from "./EngineAvatarLink.vue?vue&type=script&lang=js"

import "./EngineAvatarLink.vue?vue&type=style&index=0&id=06c77e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c77e94"]])

export default __exports__